var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"mb-2 mt-4",attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('router-link',{attrs:{"to":"/login"}},[_c('img',{attrs:{"src":require("@/assets/ffly4u_desktop.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }